import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import classNames from "classnames"

const Background = ({ blok }) => {
  const bgColor = blok
    ?.filter(item => item.component === "background_color")
    ?.pop()?.color

  return (
    !!blok?.length && (
      <div className={classNames("background-settings", bgColor)}>
        {blok.map(item => {
          return (
            <StoryblokComponent
              key={item._uid}
              blok={item}
              {...storyblokEditable(item)}
            />
          )
        })}
      </div>
    )
  )
}

export default Background
